import axios from '@/axios'

const paymenttransfer={
  // 第三方获取支付方式接口
  async GetAllQuickPaymentType(params) {
    return await axios.post('/uc/payMode/GetAllQuickPaymentType?platform=' + params.platform)
  },
  // 订单号过去pid
  async GetPIDByOrderCode(params) {
    return await axios.get('/api/services/app/Order/GetPIDByOrderCode', { params })
  },
  //获取订单详情（同蚂蚁钱包接口）
  async GetOrderDetail(params) {
    return await axios.get("/api/services/app/Order/GetOrderDetail", { params })
  },
  // pid支付宝扫码  开关
  async GetAliPayJumpAliPayStatus(params) {
    return await axios.get("/api/services/app/Configuration/GetAliPayJumpAliPayStatus", { params })
  }, //支付二维码转码
  async DownloadQRCode(params) {
    return await axios.post("/api/services/app/QucikPaymentManage/DownloadQRCode?codeName=" + params.codeName + "&orderId=" + params.orderId)
  },






  


  // 获取所有银行信息并通过名称首字母
  async GetBanksLetters(params) {
    return await axios.post('/api/services/app/BankManager/GetBanksLetters')
  },
  //创建订单
  async QuickCreateOrder(params) {
    return await axios.post('/api/services/app/QucikPaymentManage/QuickCreateOrder', params)
  },
  //确认付款(不用)
  async ConfirmationInGold(params){
    return await axios.post("/api/services/app/Order/ConfirmationInGold?orderId=" + params.orderId + '&userId=' + params.userId)
  },
  //确认付款
  async TransactionConfirmation(params){
    return await axios.post("/api/services/app/Order/TransactionConfirmation", params)
  },
  //取消订单
  async UpdateOrderStatus(params){
    return await axios.put("/api/services/app/Order/UpdateOrderStatus?OrderStatus=" + 2 + '&OrderId=' + params.OrderId + '&UserId=' + params.UserId)
  },
  //获取系统设置用户可关闭订单数量
  async GetCloseOrderNum(params) {
    return await axios.get("/api/services/app/Order/GetCloseOrderNum?settingType=" + 1)
  },

  //获取支付宝跳转银行卡开关状态
  async GetAliPayJumpBankStatusasync (params){
    return await axios.get("/api/services/app/Configuration/GetAliPayJumpBankStatus", { params })
  },

  //获取支付宝跳转银行卡开关状态2
  async GetAliPayJumpBankSecondStatus(params){
    return await axios.get('/api/services/app/Configuration/GetAliPayJumpBankSecondStatus', { params })
  },
  // 支付宝转银行卡方式2  储存数据
  async addStoringData(params){
    return await axios.post("/api/services/app/DataStorage/StoringData", params)
  }
}

export default paymenttransfer


// WEBPACK FOOTER //
// ./src/api/paymenttransfer.js